import {Exchange} from '../../../enums/exchange';
import {Side} from '../../../enums/side';
import {Security} from '../../../models/security';
import {SecurityKey} from '../../../models/security-key';

/**
 * Doc.: http://confluence.devpool.com:8195/display/HED/Autospreader
 */
export interface AspreaderSecurity extends Security {
    securityExchange: Exchange.AUTOSPREADER;
}

export interface AspreaderSecurityKey extends SecurityKey {
    securityExchange: Exchange.AUTOSPREADER;
}

export interface AspreaderSecurityConfig {
    name: string;
    userId: number;
    legs: AspreaderSecurityLeg[];
}

export interface AspreaderSecurityLeg {
    securityKey: SecurityKey;
    side: Side;
    qtyRatio: number;
    priceRatio: number;
    activeQuoting: boolean;
    payUp: number;
    stopTimeout: number;
}

export const isAspreaderExchange = (exchange: Exchange): boolean => {
    return exchange === Exchange.AUTOSPREADER;
};

export const isAsecurityKey = (securityKey: SecurityKey): securityKey is AspreaderSecurityKey => {
    return isAspreaderExchange(securityKey.securityExchange);
};

export const isAsecurity = (security: Security): security is AspreaderSecurity => {
    return isAsecurityKey(security);
};

export const parseAsecurityConfig = (asecurity: Security | AspreaderSecurity): AspreaderSecurityConfig => {
    let result: AspreaderSecurityConfig;

    if (isAsecurity(asecurity) && asecurity.longDescription) {
        try {
            result = JSON.parse(asecurity.longDescription);

            if (result && result.legs) {
                result.legs = result.legs.map(apiLeg => {
                    const [
                              symbol,
                              securityExchange,
                              currency
                          ] = apiLeg.securityKey as unknown as [string, Exchange, string];

                    return {
                        ...apiLeg,
                        securityKey: {
                            symbol,
                            securityExchange,
                            currency
                        }
                    };
                });
            }
        } catch (e) {
            // Not handled
        }
    }

    return result;
};

export const prepareAsecurityConfigForApi = (asecurityConfig: AspreaderSecurityConfig): AspreaderSecurityConfig => ({
    ...asecurityConfig,
    legs: asecurityConfig.legs.map(leg => ({
        ...leg,
        securityKey: leg.securityKey && [
            leg.securityKey.symbol,
            leg.securityKey.securityExchange,
            leg.securityKey.currency
        ] as unknown as SecurityKey
    }))
});
